import React from 'react';
import PropTypes from 'prop-types';
import {completeBuckarooOnboardingMerchantRequest, fetchSenderOnboarding} from "../services";
import Fetch, {withRefresh} from "../Elements/Fetch";
import SenderOnboardingCompleteBuckarooOnboardingMerchantRequestForm
    from "./SenderOnboardingCompleteBuckarooOnboardingMerchantRequestForm";

const SenderOnboardingCompleteBuckarooOnboardingMerchantRequestRoute = ({match, history, onSubmit, triggerRefresh}) => {
    return (
        <Fetch fetchFunction={fetchSenderOnboarding} fetchFunctionParams={match.params.id}>
            {senderOnboarding => {
                const handleAction = async () => {
                    try {
                        await completeBuckarooOnboardingMerchantRequest(senderOnboarding.id);
                        onSubmit();
                    } finally {
                        triggerRefresh(`senderOnboarding:${senderOnboarding.id}`, true);
                    }
                };

                return (
                    <SenderOnboardingCompleteBuckarooOnboardingMerchantRequestForm
                        onAction={handleAction}
                    />
                );
            }}
        </Fetch>
    );
};

SenderOnboardingCompleteBuckarooOnboardingMerchantRequestRoute.propTypes = {
    onSubmit: PropTypes.func,
};

export default withRefresh(SenderOnboardingCompleteBuckarooOnboardingMerchantRequestRoute);